"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = exports.v3ErrorMessage = exports.topLevelPaths = exports.supportedAuthProviders = exports.defaultConfig = exports.actionTypes = exports.actionsPrefix = void 0;
var actionsPrefix = "@@reactReduxFirebase";
exports.actionsPrefix = "@@reactReduxFirebase";
var actionTypes = {
  START: "".concat("@@reactReduxFirebase", "/START"),
  SET: "".concat("@@reactReduxFirebase", "/SET"),
  REMOVE: "".concat("@@reactReduxFirebase", "/REMOVE"),
  MERGE: "".concat("@@reactReduxFirebase", "/MERGE"),
  SET_PROFILE: "".concat("@@reactReduxFirebase", "/SET_PROFILE"),
  LOGIN: "".concat("@@reactReduxFirebase", "/LOGIN"),
  LOGOUT: "".concat("@@reactReduxFirebase", "/LOGOUT"),
  LOGIN_ERROR: "".concat("@@reactReduxFirebase", "/LOGIN_ERROR"),
  NO_VALUE: "".concat("@@reactReduxFirebase", "/NO_VALUE"),
  UNAUTHORIZED_ERROR: "".concat("@@reactReduxFirebase", "/UNAUTHORIZED_ERROR"),
  ERROR: "".concat("@@reactReduxFirebase", "/ERROR"),
  CLEAR_ERRORS: "".concat("@@reactReduxFirebase", "/CLEAR_ERRORS"),
  SET_LISTENER: "".concat("@@reactReduxFirebase", "/SET_LISTENER"),
  UNSET_LISTENER: "".concat("@@reactReduxFirebase", "/UNSET_LISTENER"),
  AUTHENTICATION_INIT_STARTED: "".concat("@@reactReduxFirebase", "/AUTHENTICATION_INIT_STARTED"),
  AUTHENTICATION_INIT_FINISHED: "".concat("@@reactReduxFirebase", "/AUTHENTICATION_INIT_FINISHED"),
  SESSION_START: "".concat("@@reactReduxFirebase", "/SESSION_START"),
  SESSION_END: "".concat("@@reactReduxFirebase", "/SESSION_END"),
  FILE_UPLOAD_START: "".concat("@@reactReduxFirebase", "/FILE_UPLOAD_START"),
  FILE_UPLOAD_ERROR: "".concat("@@reactReduxFirebase", "/FILE_UPLOAD_ERROR"),
  FILE_UPLOAD_PROGRESS: "".concat("@@reactReduxFirebase", "/FILE_UPLOAD_PROGRESS"),
  FILE_UPLOAD_COMPLETE: "".concat("@@reactReduxFirebase", "/FILE_UPLOAD_COMPLETE"),
  FILE_DELETE_START: "".concat("@@reactReduxFirebase", "/FILE_DELETE_START"),
  FILE_DELETE_ERROR: "".concat("@@reactReduxFirebase", "/FILE_DELETE_ERROR"),
  FILE_DELETE_COMPLETE: "".concat("@@reactReduxFirebase", "/FILE_DELETE_COMPLETE"),
  AUTH_UPDATE_START: "".concat("@@reactReduxFirebase", "/AUTH_UPDATE_START"),
  AUTH_UPDATE_SUCCESS: "".concat("@@reactReduxFirebase", "/AUTH_UPDATE_SUCCESS"),
  AUTH_UPDATE_ERROR: "".concat("@@reactReduxFirebase", "/AUTH_UPDATE_ERROR"),
  PROFILE_UPDATE_START: "".concat("@@reactReduxFirebase", "/PROFILE_UPDATE_START"),
  PROFILE_UPDATE_SUCCESS: "".concat("@@reactReduxFirebase", "/PROFILE_UPDATE_SUCCESS"),
  PROFILE_UPDATE_ERROR: "".concat("@@reactReduxFirebase", "/PROFILE_UPDATE_ERROR"),
  EMAIL_UPDATE_START: "".concat("@@reactReduxFirebase", "/EMAIL_UPDATE_START"),
  EMAIL_UPDATE_SUCCESS: "".concat("@@reactReduxFirebase", "/EMAIL_UPDATE_SUCCESS"),
  EMAIL_UPDATE_ERROR: "".concat("@@reactReduxFirebase", "/EMAIL_UPDATE_ERROR"),
  AUTH_RELOAD_START: "".concat("@@reactReduxFirebase", "/AUTH_RELOAD_START"),
  AUTH_RELOAD_ERROR: "".concat("@@reactReduxFirebase", "/AUTH_RELOAD_ERROR"),
  AUTH_RELOAD_SUCCESS: "".concat("@@reactReduxFirebase", "/AUTH_RELOAD_SUCCESS"),
  AUTH_LINK_START: "".concat("@@reactReduxFirebase", "/AUTH_LINK_START"),
  AUTH_LINK_ERROR: "".concat("@@reactReduxFirebase", "/AUTH_LINK_ERROR"),
  AUTH_LINK_SUCCESS: "".concat("@@reactReduxFirebase", "/AUTH_LINK_SUCCESS"),
  AUTH_EMPTY_CHANGE: "".concat("@@reactReduxFirebase", "/AUTH_EMPTY_CHANGE")
};
exports.actionTypes = actionTypes;
var defaultConfig = {
  userProfile: null,
  presence: null,
  sessions: "sessions",
  enableLogging: !1,
  logErrors: !0,
  preserveOnLogout: null,
  preserveOnEmptyAuthChange: null,
  resetBeforeLogin: !0,
  updateProfileOnLogin: !0,
  enableRedirectHandling: !0,
  autoPopulateProfile: !1,
  setProfilePopulateResults: !1,
  dispatchOnUnsetListener: !0,
  dispatchRemoveAction: !1,
  enableEmptyAuthChanges: !0,
  firebaseStateName: "firebase",
  attachAuthIsReady: !1,
  keysToRemoveFromAuth: ["appName", "apiKey", "authDomain", "redirectEventId", "stsTokenManager", "uid"],
  keysToPreserveFromProviderData: ["email", "phoneNumber", "photoURL", "providerId", "uid"]
};
exports.defaultConfig = defaultConfig;
var supportedAuthProviders = ["google", "github", "twitter", "facebook", "microsoft.com"];
exports.supportedAuthProviders = supportedAuthProviders;
var topLevelPaths = ["auth", "profile", "ordered", "data"];
exports.topLevelPaths = topLevelPaths;
var v3ErrorMessage = "Context from react-redux not found. If you are using react-redux v6 a v3.*.* version of react-redux-firebase is required. Please checkout the v3 migration guide: http://bit.ly/2SRNdiO";
exports.v3ErrorMessage = "Context from react-redux not found. If you are using react-redux v6 a v3.*.* version of react-redux-firebase is required. Please checkout the v3 migration guide: http://bit.ly/2SRNdiO";
var _default = {
  actionTypes: actionTypes,
  defaultConfig: defaultConfig
};
exports.default = _default;